module.exports = __webpack_public_path__ + "media/earth2.d9ae2359.mp4";